class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  /*
   * Closing is deliberately NOT left to the base class.
   *
   * DetailsDisclosure closes on `focusout` via a 0ms timeout. `focusout` fires on mousedown, while
   * <details> opens on click — that is, mouseup. The timeout resolves comfortably in between, so
   * switching from one mega menu to another closed the first on press and opened the second on
   * release, with a blank gap in between for as long as the button was held. That gap is the flicker.
   *
   * Instead the close is delayed past the click, and the menu being opened closes its siblings itself
   * (see onToggle). The swap then happens inside a single toggle handler, before the browser paints,
   * so one panel replaces the other with no frame where neither is visible.
   *
   * The timer still runs as the fallback that covers every other way focus can leave — tabbing out,
   * or clicking page content, where nothing else would close the menu. It is short enough to read as
   * immediate and long enough to outlast a normal click.
   */
  onFocusOut() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      this.close();
    }, HeaderMenu.CLOSE_DELAY);
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    // Swap in one frame: the menu that just opened closes any other that is still open, rather than
    // each menu closing itself on focusout.
    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu === this || typeof menu.close !== 'function') return;
        if (menu.querySelector('details[open]')) menu.close();
      });
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

HeaderMenu.CLOSE_DELAY = 150;

customElements.define('header-menu', HeaderMenu);
